const notificationsPaymentForSendingsWithPaymentType102 = (
  valueTotalNotifications, userBalance, collectionService,
) => collectionService && (userBalance - valueTotalNotifications >= 0);

export default notificationsPaymentForSendingsWithPaymentType102;
